import React, { useState, useEffect } from "react";
import TextField from "../../../Components/UI/Inputs/TextField";
import Password from "../../../Components/UI/Inputs/Password";
import Button from "../../../Components/UI/Buttons/Button";
import DropDown from "../../../Components/UI/Inputs/DropDown";
import showToast from "../../../Helpers/toast";
import NavigateButton from "../../../Components/UI/Buttons/NavigateButton";
import useApi from "../../../Hooks/useApi";
import { useNavigate } from "react-router-dom";
import MultiLocationSelector from "../../../Components/UI/Inputs/LocationSelector/LocationSelectorContainer";
import { handleApiError } from "../../../Helpers/ErrorHandler";
import Common from "../../../Components/Layouts/Common";

const AddUser = () => {
  const initialFormState = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirm_password: "",
    designationId: "",
    departmentId: "",
    userType: "",
  };
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormState);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState(null);
  const { loading, request } = useApi();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [departmentsData, designationsData, rolesData] =
          await Promise.all([
            request("GET", "/v1/departments"),
            request("GET", "/v1/designations"),
            request("GET", "/v1/roles"),
          ]);

        setDepartments(departmentsData);
        setDesignations(designationsData);

        setRoles(rolesData);
      } catch (error) {
        setErrors(error);
      }
    };

    fetchData();
  }, [request]);

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let data = { ...formData };

    if (
      !data.email
        ?.trim()
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      setErrors({ message: "Invalid email" });
      showToast({ message: "Please provide a valid email!", type: "error" });
      return false;
    }
    if (!data.designationId) {
      setErrors({ message: "Designation is required!" });
      showToast({
        message: "Please select appropriate Designation!",
        type: "error",
      });
      return false;
    }
    if (!data.departmentId) {
      setErrors({ message: "Department is required!" });
      showToast({
        message: "Please select appropriate Department!",
        type: "error",
      });
      return false;
    }
    if (!data.userType?.name) {
      setErrors({ message: "User-Type is required!" });
      showToast({ message: "Please select a user-type", type: "error" });
      return false;
    }
    if (data.password && data.confirm_password) {
      if (data.password !== data.confirm_password) {
        setErrors({ message: "Passwords do not match" });
        showToast({ message: "Passwords do not match!", type: "error" });
        return false;
      }
      if (data.password.trim() < 6) {
        setErrors({ message: "Passwords is too short!" });
        showToast({ message: "Passwords is too short!", type: "error" });
      }
    } else {
      setErrors({ message: "Enter and Confirm password" });
      showToast({ message: "Enter and Confirm password", type: "error" });
      return false;
    }

    delete data.confirm_password;
    return data;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = validate();

    if (data) {
      data.userType = data?.userType?.value;

      try {
        const response = await request("POST", "/v1/user/add", {
          data: {
            ...data,
          },
        });

        showToast({ message: response?.message || "User Added Successfully!" });
        navigate("/manage-users");
        setFormData(initialFormState);
      } catch (error) {
        showToast({
          message:
            error?.response?.data?.message || "Error Occurred! Try again.",
          type: "error",
        });

        setErrors(error);
      }
    }
  };

  

  return (
    <div className="px-2 h-full">
      <Common headline={"Add User"}>
        <div className="lg:grid grid-cols-2 gap-4">
          <TextField
            label="First Name"
            name="firstName"
            onValueChange={handleInputChange}
            value={formData.firstName}
          />

          <TextField
            label="Last Name"
            name="lastName"
            onValueChange={handleInputChange}
            value={formData.lastName}
          />
          <TextField
            label="Email"
            name="email"
            onValueChange={handleInputChange}
            value={formData.email}
          />

          <DropDown
            label="Role"
            placeholder={"Select Role"}
            name="userType"
            baggage={true}
            onValueChange={(value) => handleInputChange("userType", value)}
            value={formData.userType}
            options={roles
              .map((role) => ({
                name: role.name,
                value: role.id,
              }))
              .filter((item) => !item.name?.toLowerCase()?.includes("imis"))}
          />

         
        
              <DropDown
                label="Department"
                name="departmentId"
                placeholder={"Select Department"}
                options={departments.map((department) => ({
                  name: department.name,
                  value: department.id,
                }))}
                onValueChange={(value) =>
                  handleInputChange("departmentId", value)
                }
                value={formData.departmentId}
              />
              <DropDown
                label="Designation"
                name="designationId"
                placeholder={"Select Designation"}
                options={designations.map((designation) => ({
                  name: designation.name,
                  value: designation.id,
                }))}
                onValueChange={(value) =>
                  handleInputChange("designationId", value)
                }
                value={formData.designationId}
              />
         
         
          <Password
            label="Password"
            name="password"
            onValueChange={handleInputChange}
            value={formData.password}
          />

          <Password
            label="Confirm Password"
            name="confirm_password"
            onValueChange={handleInputChange}
            value={formData.confirm_password}
          />


          <div className="col-span-2 flex justify-center">
  <Button
    type="full"
    label={loading ? "Submitting..." : "Submit"}
    handler={handleSubmit}
    disabled={loading}
    style={{ width: "200px" }}
  />
</div>

        </div>
      </Common>
    </div>
  );
};
export default AddUser;
